module.exports = __webpack_public_path__ + "fe6dee90ed14d2086f5dfeb83f3ae272.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/sushi-s.png
// module id = 2744
// module chunks = 0